import React from "react";
import potrait from "../images/you.png";
import { Link, BrowserRouter, Routes, Route } from "react-router-dom";
import horizontal from "../images/horizontal.png";
import { BsArrowRight } from "react-icons/bs";
import resume from "../Mayowa-abikoye-resume.pdf";

const InformationDesktop = () => {
	return (
		<>
			<div
				style={{
					display: "grid",
					// flexWrap: "wrap",
					gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
					gap: "3%",
					width: "90%",
					margin: "5% auto",
				}}
			>
				<div
					style={{
						width: "100%",
						maxWidth: "100%",
						// border: "2px solid black",
						textAlign: "left",
						padding: "3% 3%",
						margin: "auto 0 ",
					}}
				>
					<h2>
						<span style={{ color: "white", fontWeight: "bolder" }}>
							Mayowa is a
						</span>
						<span style={{ color: "#C778DD" }}> BlockChain Engineer</span>
						<span style={{ color: "white" }}> and</span>
						<span style={{ color: "#C778DD" }}> Full-Stack Web Developer</span>
					</h2>
					<h3 style={{ color: "#ABB2BF" }}>
						I develop Applications that utilize both Blockchain and
						Non-Blockchain Technologies
					</h3>
					<button
						style={{
							border: "2px solid #C778DD",
							// background: "#282C33",
							backGround: "#282c33",
							padding: "2% 4%",
							marginTop: "3%",
							marginBottom: "3%",
							// borderRadius: "12%",
						}}
					>
						<Link
							to="/contacts"
							style={{ textDecoration: "none", color: "white" }}
						>
							Contact Me
						</Link>
					</button>
				</div>
				<div
					style={{
						display: "flex",
						// border: "2px solid yellow",
						flexDirection: "column",
						justifyContent: "end",
						// alignItems: "end",
					}}
				>
					<div style={{ textAlign: "right", float: "right" }}>
						<img
							src={potrait}
							alt=""
							style={{
								width: "70%",
								float: "right",
								// border: "2px solid red",
								// border: "1px solid black",
							}}
						/>
					</div>
					<div
						style={{
							width: "55%",
							marginLeft: "auto",
							display: "flex",
							justifyContent: "start",
							alignItems: "center",
							textAlign: "center",
							gap: "1%",
							// border: "3px solid green",
						}}
					>
						<div
							style={{
								width: "10px",
								height: "14px",

								background: "#C778DD",
								borderLeft: "0.50px #C778DD solid",
								borderTop: "0.50px #C778DD solid",
								borderRight: " 0.50px #Cadd778DD solid",
								borderBottom: "0.50px #C778DD solid",
							}}
						></div>
						<div>
							<Link
								to={resume}
								download="Mayowa-Abikoye_Resume"
								target="_blank"
								rel="noreferrer"
								style={{
									textDecoration: "none",
									color: "white",
									fontWeight: "bolder",
									// textAlign:'center'
									// float: "right",
								}}
							>
								Download Resume
							</Link>
						</div>
					</div>
				</div>
			</div>

			<div style={{ width: "40%", margin: "10% auto" }}>
				<div style={{ color: "white" }} className="quotations">
					In a Different Class Of My Own
				</div>
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						float: "right",
						border: "2px solid #abb2bf",
						width: "30%",
						height: "60px",
						maxWidth: "60%",
						maxHeight: "80px",
						marginBottom: "5%",
					}}
				>
					<span style={{ color: "white" }}> Mayowa</span>
				</div>
			</div>

			<div
				style={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
					width: "90%",
					// marginTop: "10%",
					margin: "15% auto 0 auto",
					// border: "2px solid orange",
				}}
			>
				<div
					style={{
						display: "flex",
						justifyContent: "space-between",
						alignItems: "center",
					}}
				>
					<span style={{ color: "#C778DD" }}>#</span>
					<h3 style={{ color: "white", fontWeight: "bolder" }}>Projects</h3>
					<img src={horizontal} alt="" />
				</div>
				<div
					style={{
						color: "white",
						display: "flex",
						alignItems: "center",
					}}
				>
					<span>
						<Link to="/works">View</Link>
					</span>
					<BsArrowRight />
				</div>
			</div>
		</>
	);
};
export default InformationDesktop;
